import React from 'react';
import {useDownloadURL} from "react-firebase-hooks/storage";
import {firebaseStorage, storageRef} from "../../firebase/client-app";
import {UPLOADED_IMAGES_PATH} from "../../common/constants/image.constant";
import {getDownloadURL} from "@firebase/storage";

const ImageSidebarItem = ({
                              imageDetail,
                              setSelectedImage,
                              selectedImageIdsList,
                              removeImage = undefined,
                              showRemove = false
                          }) => {
    const [value, loading, error] = useDownloadURL(storageRef(firebaseStorage, imageDetail?.thumbnail));

    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };
    let size = modes['fit'] || 'contain';

    let defaults = {
        height: 100,
        width: 100,
        backgroundColor: 'bg-white',
    };

    const handleDragStart = async (event) => {
        setSelectedImage(imageDetail);
    }

    const addImage = async (imageDetail) => {
        imageDetail.isAdded = true;
        setSelectedImage(imageDetail);
    }

    return (
        <>
            {!loading && value &&
                <div className="border-gray-200 bg-white hover:bg-neutral-400 border rounded m-1 cursor-pointer p-2">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: `url("${value}")`
                    }}
                         draggable="true"
                         onDragStart={handleDragStart}/>

                    {!selectedImageIdsList || selectedImageIdsList?.indexOf(imageDetail?.id) === -1 &&
                        <div className="mt-2">
                            <button onClick={() => {
                                addImage(imageDetail)
                            }} className="button-outline-green h-8 w-full m-auto">
                                Add
                            </button>
                        </div>
                    }

                    {selectedImageIdsList?.indexOf(imageDetail?.id) !== -1 &&
                        <>
                            {showRemove &&
                                <div className="mt-2">
                                    <button onClick={() => {
                                        removeImage(imageDetail);
                                    }} className="button-red-outline h-8 w-full m-auto">
                                        Remove
                                    </button>
                                </div>
                            }

                            {!showRemove &&
                                <div className="mt-2">
                                    <button onClick={() => {
                                    }} className="button-green h-8 w-full m-auto">
                                        Added
                                    </button>
                                </div>
                            }
                        </>
                    }
                </div>
            }

            {loading && !value &&
                <div className="border-gray-200 bg-white hover:bg-neutral-400 border rounded m-1 cursor-pointer p-2">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}/>
                </div>
            }

        </>
    )
}

export default ImageSidebarItem
